export default () => [
  {
    type: 'dropdown',
    icon: 'fa-list',
    variant: 'default-outline',
    items: [
      {
        type: 'button',
        text: 'Редактировать',
        action: 'openEditForm',
        permission: 'all',
      },
      {
        type: 'button',
        text: 'Удалить',
        action: 'remove',
        permission: 'all',
      },
    ],
  },
];
